import { zs } from '../schemas/zod';

export const prioritySchema = zs.enum(['high', 'medium', 'low']);

export type Priority = (typeof prioritySchema.options)[number];
